/**
 * Removes the country code from a registration e.g. `NL|12-AB-34` to `12-AB-34`
 */
export function formatRegistration(registration: string) {
  const [, alphanumeric] = registration.split('|')

  return alphanumeric
}
